import React, {useRef, useEffect, useState} from 'react';
import {Icon} from 'components';
import {over, stopPropagation, getElementAttributes} from 'helpers';
import css from './checkbox.module.scss';

export function Checkbox({ children, checked, error, ...props }) {
  const ref = useRef();
  const [onClick, setOnClick] = useState(() => props.onClick);
  useEffect(() => {
    if (props.onClick && !ref.current.closest('a')) {
      setOnClick(() => over(props.onClick, stopPropagation));
    }
  }, []);
  return (
    <span {...getElementAttributes(props)} onClick={onClick} className={css('checkbox', props, checked && 'is-checked', error && 'has-error')} role="checkbox" aria-checked={!!checked} ref={ref}>
      { checked &&
        <Icon name={props.radio ? 'circle' : 'check'} className={css.icon} />
      }
      { children }
    </span>
  );
}

Checkbox.Container = function Container({ children, onClick, className, id, ...props }) {
  return (
    <label className={css('container', className, { 'container-checked': props.checked, 'muted': props.muted } )} onClick={onClick} id={id}>
      <Checkbox {...props} />
      { children }
    </label>
  );
}
